var _style, _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: 60,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #ffffff;stroke: #000000;stroke-linejoin:round;stroke-width: 1.229 } \n\t\t.shp1 { fill: #000000;stroke: #000000;stroke-width: 0.153 } \n\t\t.shp2 { opacity: 0.251;fill: #ffffff } \n\t\t.shp3 { opacity: 0.349;fill: #ffffff } \n\t\t.shp4 { fill: #ffffff } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M4.13 7.26C33.87 -14.76 69.49 32.49 56.66 49.3C32.81 77.28 30.55 38.91 18.62 30.5C12.13 24.39 -7.04 16.59 4.13 7.26ZM24.58 27.83C21.11 32.27 26.99 37.77 31.97 33.64C35.45 29.21 28.8 24.47 24.58 27.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M6.17 9.23C10.44 5.83 17.14 10.63 13.64 15.12C8.61 19.31 2.66 13.73 6.17 9.23L6.17 9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M23.24 6.29C27.51 2.88 34.22 7.69 30.71 12.18C25.68 16.36 19.74 10.79 23.24 6.29L23.24 6.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M38.18 15.74C42.45 12.34 49.16 17.14 45.65 21.63C40.62 25.82 34.67 20.24 38.18 15.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M46.87 30.47C51.14 27.05 57.85 31.86 54.34 36.36C49.31 40.54 43.36 34.96 46.87 30.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M41.38 49.06C45.65 45.65 52.36 50.45 48.85 54.95C43.82 59.14 37.88 53.55 41.38 49.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp1",
    d: "M8.93 58.91C8.93 58.91 11.85 58.68 15.08 53.28C16.7 52.1 17.62 52.1 18.89 50.57C20.51 47.63 19.13 46.34 17.86 45.87C16.24 45.87 16.93 45.28 13.81 46.11C10.69 48.58 10.92 48.81 10.81 51.86C11.15 55.74 9.97 58.09 8.93 58.91L8.93 58.91Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp2",
    d: "M42.81 16.01C40.54 13.71 35.1 18.32 39.29 21.43C42.92 21.08 36.91 16.7 42.81 16.01Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M18.53 35.86C20.5 26.69 46.72 0.74 46.72 0.74L46.72 0.74L46.84 0.63C46.72 0.63 36.9 29.87 25.47 39.39C23.73 37.38 23.39 38.09 22.12 36.92C21.19 36.56 18.42 35.98 18.53 35.86L18.53 35.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M14.5 44.35C18.2 37.07 18.32 36.6 18.32 36.6C18.32 36.6 19.36 36.24 21.09 36.13C22.71 36.71 23.17 36.83 24.32 37.66C25.02 39.06 25.83 39.88 25.83 39.88L20.05 47.52C20.05 47.52 17.86 44.35 14.5 44.35L14.5 44.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M13.81 45.64C13.93 45.64 16.24 45.87 17.05 46.11C17.86 46.34 19.59 47.87 19.7 48.1C19.82 48.34 19.94 48.1 20.28 48.34C20.63 48.58 21.09 47.76 21.09 47.4C20.63 46.34 20.15 45.25 18.41 44.9C16.68 44.32 13.98 43.6 13.63 44.3C13.4 44.77 13 45.17 13.12 45.28C13.23 45.41 13.93 45.87 13.81 45.64L13.81 45.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M18.66 36.71C18.66 36.71 19.74 36.68 21.01 37.04C22.05 37.27 23.17 37.59 24.21 38.64C24.79 39.47 25.25 39.88 26.06 39.88C26.87 39.88 26.87 39.77 26.87 39.06C26.63 38.36 26.06 37.66 25.13 36.71C24.21 36.01 22.71 35.42 21.32 34.95C19.93 34.84 18.43 34.48 17.62 35.42C17.51 36.01 17.74 36.48 17.74 36.48L18.66 36.71L18.66 36.71Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp3",
    d: "M20.05 34.13C19.47 31.55 40.74 7 44.55 3.71C48.36 0.43 22.24 29.56 22.24 34.14C22.01 34.37 19.93 34.25 20.05 34.13L20.05 34.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp4",
    d: "M9.71 57.88C9.71 57.88 11.73 56.8 11.39 54.09C11.04 51.4 11.04 50.68 11.73 48.93C12.77 47.4 13.81 46.46 14.16 46.7C15.08 47.52 13.58 47.76 12.89 49.64C12.19 51.51 12.66 52.69 12.19 54.8C11.62 57.03 9.71 58.01 9.71 57.88L9.71 57.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.251
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp4",
    d: "M10.7 9.31C8.43 7 2.99 11.61 7.18 14.73C10.81 14.38 4.8 10 10.7 9.31L10.7 9.31Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp4",
    d: "M51.53 30.64C49.27 28.34 43.83 32.95 48.02 36.06C51.65 35.72 45.64 31.33 51.53 30.64Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp4",
    d: "M45.75 49.3C43.49 47 38.05 51.61 42.24 54.72C45.87 54.38 39.86 49.99 45.75 49.3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp4",
    d: "M27.96 6.34C25.69 4.03 20.25 8.63 24.45 11.75C28.07 11.4 22.07 7.03 27.96 6.34Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.4919f2b1065b239ec87dbe8074ca3e41.svg";
export { ForwardRef as ReactComponent };